import { useCallback } from 'react';
import axios, { CancelToken } from 'axios';
import { useStore } from 'components/Store';
import { parseServerError } from 'helpers/errorHelpers';
import { getRequestConfig } from 'screens/Applications&WorkOrders/apiHelpers';
import { CROPWISE_PROXY_URL } from 'utilities/apiConstants';
import {
  RecommendationLinkedRecordsParams,
  RecommendationLinkedRecordsResponse
} from './linkedRecords.types';

/** Newest-first, matching the order the linked-records list is specified in. */
export const LINKED_RECORDS_SORT = 'startDate,desc';

const useRecommendationLinkedRecords = () => {
  const {
    state: { organization },
    dispatch
  } = useStore();

  const getLinkedRecords = useCallback(
    async (
      { recommendationId, page, size }: RecommendationLinkedRecordsParams,
      cancelToken?: CancelToken
    ): Promise<RecommendationLinkedRecordsResponse> => {
      const config = getRequestConfig(organization.id, cancelToken);

      const searchParams = new URLSearchParams({
        page: String(page),
        size: String(size),
        // Singular `sort` — `sorts` is silently ignored by Spring's resolver,
        // which then falls back to the controller's default ordering.
        sort: LINKED_RECORDS_SORT
      });

      try {
        const response = await axios.get<RecommendationLinkedRecordsResponse>(
          `${CROPWISE_PROXY_URL}/v1/recommendation/${recommendationId}/linked-records?${searchParams.toString()}`,
          config
        );
        return response.data;
      } catch (error) {
        if (!axios.isCancel(error)) {
          parseServerError(dispatch)(error);
        }
        throw error;
      }
    },
    [organization.id, dispatch]
  );

  return { getLinkedRecords };
};

export default useRecommendationLinkedRecords;
